import { gridOutline, informationCircleOutline } from 'ionicons/icons';
import PillListPage, { PillListItem } from 'components/PillListPage/PillListPage';
import {
  HOW_TO_VIDEOS_URL,
  profileIcon,
  supportTicketIcon,
  termsAndServiceIcon,
  videoIcon,
} from 'config/config';

const OTHER_ITEMS: PillListItem[] = [
  { title: 'Support Center', icon: supportTicketIcon, path: '/support-center' },
  { title: 'Account Info', icon: profileIcon, path: '/profile' },
  { title: 'Terms and Conditions', icon: termsAndServiceIcon, path: '/terms' },
  { title: 'How to Videos', icon: videoIcon, external: HOW_TO_VIDEOS_URL },
  { title: 'Definitions', icon: informationCircleOutline, path: '/definitions', isIonIcon: true },
];

const Other: React.FC = () => (
  <PillListPage className="other-page" title="Other" titleIcon={gridOutline} items={OTHER_ITEMS} />
);

export default Other;
